"use strict";

define('rs/modals/meeting.finder/meeting.finder.controller',['vertebrae', 'rs/modals/table.finder/table.finder.controller', './meeting.finder.view', 'rs/models/meeting', 'rs/models/group', 'moment'], function (Vertebrae, RSFinderController, MeetingFinderView, MeetingModel, GroupModel, moment) {
  var MeetingFinderController = RSFinderController.extend({
    defaultTitle: 'Meeting Finder',
    properties: ['meetings', 'board'],
    buttons: [{
      text: 'Cancel',
      icon: 'cancel',
      dismiss: true
    }, {
      text: 'Save',
      icon: 'save',
      action: 'save'
    }, {
      text: 'Create Meeting',
      icon: 'plus',
      action: 'createMeeting',
      position: 'left'
    }],
    columns: [{
      name: 'startDate',
      displayName: 'Date',
      type: 'date',
      format: 'LLL',
      width: '91%'
    }, {
      icon: 'plus',
      className: 'btn-add-member',
      width: '7%',
      sortable: false
    }],
    defaultProperties: function defaultProperties() {
      return _.extend(this._super(), {
        showFilter: false
      });
    },
    getTableOptions: function getTableOptions() {
      var options = this._super.apply(this, arguments);
      options.groupedItems = true;
      return options;
    },
    processGroupedItems: function processGroupedItems(items) {
      return _.chain(items).groupBy(function (item) {
        return item.item.startDate.getMonth();
      }).map(function (group, index) {
        var item = group[0] && group[0].item,
          title = '';
        if (item && item.startDate) {
          title = moment(item.startDate).format("MMMM YYYY");
        }
        return {
          name: title,
          items: group
        };
      }).value();
    },
    processGroupSort: function processGroupSort(items) {
      return items;
    },
    processSort: function processSort(items, filter) {
      if (filter.field) {
        return _.filter(items, function (item) {
          if (item.item[filter.field] == filter.value) {
            return true;
          }
        });
      }
      return items;
    },
    sectionIsReady: function sectionIsReady() {
      var that = this,
        start = moment().format('X'),
        end = moment().add('years', 1).format('X');
      start = Number(start) * 1000;
      end = Number(end) * 1000;
      return MeetingModel.requestAllByBoardId(this.getBoard().getId(), start, end).then(function (meetings) {
        that.setMeetings(meetings);
      }).then(this._super.proxy(this));
    },
    requestCreateMeeting: function requestCreateMeeting() {
      this.getModal().close();
      Vertebrae.Event.trigger('create-meeting');
    },
    generateDisplayName: function generateDisplayName(item) {
      return moment(item.startDate).format('LLL LT');
    },
    setupView: function setupView() {
      this.setView(new MeetingFinderView());
    },
    _requestTableItems: function _requestTableItems(searchQuery) {
      return Promise.resolve(this.getMeetings() || []);
    }
  }, {
    create: function create(properties) {
      properties.title = 'Find Meetings for ' + properties.board.getName();
      return new this(properties);
    }
  });
  return MeetingFinderController;
});

